import { useEffect, useState } from "react";

/** 画面がこの幅以上なら「PC向け」の配置に切り替える(Tailwind の md と揃える) */
export const WIDE_SCREEN_QUERY = "(min-width: 768px)";

/** マウス操作が前提の PC(Tailwind の xl と揃える)。送りボタンの有無などに使う */
export const PC_SCREEN_QUERY = "(min-width: 1280px)";

/** CSS メディアクエリの真偽を React の状態として持つ */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const list = window.matchMedia(query);
    const onChange = () => {
      setMatches(list.matches);
    };
    // query が変わった直後の値も拾う
    setMatches(list.matches);
    list.addEventListener("change", onChange);
    return () => {
      list.removeEventListener("change", onChange);
    };
  }, [query]);

  return matches;
}
